import React from 'react'
import GenericPullConfigListing from '../GenericPullConfigListing';
import RunZeroCredentialsForm from './RunZeroCredentialsForm';
import RunZeroMappingForm from './RunZeroMappingForm';

export default function RunZeroConfigListing(props) {

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={RunZeroMappingForm}
            CredentialsForm={RunZeroCredentialsForm}
            componentName="Organization"
            componentKey="organisationName"
        />
    )
}